import { useField } from "formik";
import React from "react";
import { useSelector } from "react-redux";
import Tooltip from "@material-ui/core/Tooltip";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import { makeGetTeammates } from "../../../../selectors/recruiter/teammateSelectors";
import { buildFullName } from "../../../../util/formatHelpers";
import DropdownSelect from "../../../forms/custom/DropdownSelect";
import { CONTRACT_SUPPLIER_MANAGERS } from "../../Team/constants";

export default function TimesheetSubmittersField() {
  const teammates = useSelector(makeGetTeammates(CONTRACT_SUPPLIER_MANAGERS));

  const [{ value, onBlur }, { error }, { setValue }] = useField(
    `contractSupplierIndividuals`
  );

  const options = teammates.map(({ id, attributes }) => ({
    value: id,
    label: buildFullName(attributes.firstName, attributes.lastName),
  }));

  const sectionLabel = (
    <>
      Contract Managers
      <Tooltip
        id="tooltip-icon-contract-managers-submitters"
        title="Contract managers can see workers once they begin a contract and will be responsible for managing timesheets."
        placement="right"
      >
        <InfoOutlinedIcon
          style={{
            margin: "0px 0px -2px 4px",
            fontSize: 14,
          }}
        />
      </Tooltip>
    </>
  );

  return (
    <DropdownSelect
      id="contractSupplierIndividuals"
      labelText="Contract Managers"
      label={sectionLabel}
      isMulti
      isClearable
      options={options}
      value={value}
      onChange={setValue}
      onBlur={onBlur}
      error={Boolean(error)}
      helperText={error}
    />
  );
}
